import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch((err) => err)
}
Vue.use(VueRouter)

export default new VueRouter({
  mode: "history",
  routes: [
    {
      path: '/material-index',
      meta: { title: '基础性作业资源', keepAlive: true },
      name: 'BasicHomework',
      component: () => import('@/views/material/index')
    },
    {
      path: '/material-listenning',
      meta: { title: '听力材料' },
      name: 'ListenMaterial',
      component: () => import('@/views/listening/index')
    }
  ]
})
